import { useLayoutEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { AnimalTypeEnum } from '@api/types/AnimalTypeEnum';
import AnimalDimensions from '@pages/order/summary/AnimalDimensions';
import AnimalInfo from '@pages/order/summary/AnimalInfo';
import SurgeryInfo from '@pages/order/summary/SurgeryInfo';
import Pattern from '@pages/order/summary/Pattern';
import CollarType from '@pages/order/summary/CollarType';
import CustomerInfo from '@pages/order/summary/CustomerInfo';
import CustomerAddress from '@pages/order/summary/CustomerAddress';
import PaymentShipping from '@pages/order/summary/PaymentShipping';
import Message from '@pages/order/summary/Message';
import Discount from '@pages/order/summary/Discount';
import Footer from '@pages/order/summary/footer/Footer';



interface OrderSummaryProps {
	goToForm: () => void,
}


const OrderSummary = (props: OrderSummaryProps) => {
	const { goToForm } = props;
	const { t } = useTranslation('forms');

	const summaryRef = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		summaryRef?.current?.scrollIntoView();
	}, []);

	return (
		<div className='order-summary' ref={summaryRef}>

			<div className='order-summary-header'>
				<h1 className='disable-selection' onClick={goToForm}>{t('summary.orderLabel')}</h1>
				<h1 className='disable-selection'>{t('summary.summaryLabel')}</h1>
			</div>
			
			<div className='order-summary-block'>
				<AnimalDimensions />
				<AnimalInfo />
				<SurgeryInfo />
				<Pattern animalType={AnimalTypeEnum.dog} />
				<CollarType />
			</div>

			<div className='order-summary-block customer-block'>
				<CustomerInfo />
				<CustomerAddress />
				<PaymentShipping />
				<Message />
			</div>

			<Discount />

			<Footer animalType={AnimalTypeEnum.dog} />
		
		</div>
	);
};

export default OrderSummary;